import { Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { Assessment } from 'types/analysis-result.types';

interface Props {
  userAssessment: Assessment;
}

const UserPersona: React.FC<Props> = ({ userAssessment }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const motiveIllustrationGenerator = () => {
    const baseUrl = '/dashboard/images/illustrations/';

    const motive = userAssessment?.name || '';

    return `${baseUrl}${_.replace(_.toLower(motive), ' ', '')}.png`;
  };

  return (
    <div className={classes.personaCompare}>
      <Typography className={classes.title}>{t('textImpact')}</Typography>
      <div className={classes.centered}>
        <img className={classes.illustration} src={motiveIllustrationGenerator()} alt="motive illustration" />
      </div>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  personaCompare: {
    width: '100%',
    background: '#FFF',
    border: `2px solid ${theme.palette.backgrounds.main}`,
    padding: '8px',
  },
  title: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
    marginBottom: '8px',
  },
  persona: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    textAlign: 'center',
    color: theme.palette.primary.main,
    marginBottom: '4px',
  },
  centered: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  illustration: {
    width: 'auto',
    maxHeight: '85px',
  },
}));

export default UserPersona;
